import { Outlet } from "react-router-dom";
// Import your actual Navbar component here
import Navbar from "../src/components/feature/Navbar"; 
import Footer from "../src/components/feature/Footer"; // Optional, if you have one

export default function Layout() {
  return (
    <>
      <Navbar />
      
      {/* <Outlet /> is where your pages (Home, About, etc.) will render */}
      <main>
        <Outlet /> 
      </main>

      <Footer />
    </>
  );
}